module.exports = __webpack_public_path__ + "img/splash2.3dac1ef4.png";